import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IncidentListComponent } from "../addons/incident/incident-list.component";
import { ApprovalListComponent } from "../addons/approval/approval-list.component";
import { NotificationListComponent } from "../addons/notification/notification-list.component";
import { TaskListComponent } from '../addons/task/task-list.component';

interface Task {
  id: number;
  description: string;
  dueDate: Date;
  priority: string;
  completed: boolean;
}

@Component({
  selector: 'app-canvas-view',
  standalone: true,
  imports: [CommonModule, TaskListComponent,
    IncidentListComponent, ApprovalListComponent, 
    NotificationListComponent],
  templateUrl: './canvas-view.component.html',
  styleUrl: './canvas-view.component.css'
})
export class CanvasViewComponent {

  ngOnInit() {

  }



}
